webpackJsonp([246501157640856],{

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    grid-column-gap: 0.5rem;\n    grid-template-areas:\n      \'. fs fs fs fs fs fs fs fs fs fs .\'\n      \'cont cont cont cont cont cont cont cont cont cont cont cont\';\n  '], ['\n    grid-column-gap: 0.5rem;\n    grid-template-areas:\n      \'. fs fs fs fs fs fs fs fs fs fs .\'\n      \'cont cont cont cont cont cont cont cont cont cont cont cont\';\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    grid-template-areas:\n      \'fs fs fs fs fs fs fs fs fs fs fs fs\'\n      \'cont cont cont cont cont cont cont cont cont cont cont cont\';\n  '], ['\n    grid-template-areas:\n      \'fs fs fs fs fs fs fs fs fs fs fs fs\'\n      \'cont cont cont cont cont cont cont cont cont cont cont cont\';\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _globalStyle = __webpack_require__(6);
	
	var _FilterAndSearch = __webpack_require__(35);
	
	var _FilterAndSearch2 = _interopRequireDefault(_FilterAndSearch);
	
	var _CardContainer = __webpack_require__(34);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _ProjectCard = __webpack_require__(37);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	var _Pagination = __webpack_require__(54);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _Titles = __webpack_require__(38);
	
	var _api = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'EventsContainer__Wrapper'
	})(['display:grid;grid-template-columns:repeat(12,1fr);grid-template-rows:auto;grid-column-gap:1rem;grid-template-areas:\'. . fs fs fs fs fs fs fs fs . .\' \'cont cont cont cont cont cont cont cont cont cont cont cont\';margin-top:2.5rem;', ' ', ';'], _globalStyle.media.giant(_templateObject), _globalStyle.media.tablet(_templateObject2));
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'EventsContainer__Container'
	})(['grid-area:cont;display:flex;flex-direction:column;align-content:center;']);
	
	var EventsContainer = function (_React$Component) {
	  _inherits(EventsContainer, _React$Component);
	
	  function EventsContainer(props) {
	    _classCallCheck(this, EventsContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      loading: true,
	      searchQuery: '',
	      query: [{
	        title: '',
	        image: '',
	        date: '',
	        city: '',
	        country: '',
	        description: ''
	      }]
	    };
	    _this.CARDS = { cols: 5, items: 6 };
	
	    _this.changePage = _this.changePage.bind(_this);
	    _this.handleDates = _this.handleDates.bind(_this);
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.handleInput = _this.handleInput.bind(_this);
	    return _this;
	  }
	
	  EventsContainer.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var loading = false;
	    (0, _api.fakeEventsAPI)(this.CARDS.items).then(function (query) {
	      return _this2.setState({ loading: loading, query: query });
	    });
	  };
	
	  EventsContainer.prototype.changePage = function changePage(num) {
	    var _this3 = this;
	
	    //for now it immitates querying different pages
	    var fakePage = function fakePage() {
	      var length = _this3.CARDS.items;
	      var result = void 0;
	      if (_this3.state.searchQuery) {
	        var searchQuery = _this3.state.searchQuery;
	        result = (0, _api.fakeEventsAPI)(length, undefined, undefined, searchQuery);
	      } else {
	        result = (0, _api.fakeEventsAPI)(length);
	      }
	      result.then(function (query) {
	        return _this3.setState({ query: query });
	      });
	    };
	
	    if (num === -1) {
	      //get previous page
	      fakePage();
	    } else if (num === 0) {
	      // get next page
	      fakePage();
	    } else {
	      //get page #num
	      fakePage();
	    }
	  };
	
	  EventsContainer.prototype.handleDates = function handleDates(str) {
	    var _this4 = this;
	
	    // immitation of new query
	    var length = str === 'all' ? this.CARDS.items : Math.floor(Math.random() * (this.CARDS.items + 1)),
	        city = str === 'my area' ? 'My City' : '',
	        country = str === 'my area' ? 'My Country' : '';
	    var result = void 0;
	
	    if (this.state.searchQuery) {
	      var searchQuery = this.state.searchQuery;
	      result = (0, _api.fakeEventsAPI)(length, city, country, searchQuery);
	    } else {
	      result = (0, _api.fakeEventsAPI)(length, city, country);
	    }
	
	    result.then(function (query) {
	      return _this4.setState({ query: query });
	    });
	  };
	
	  EventsContainer.prototype.handleSearch = function handleSearch() {
	    var _this5 = this;
	
	    //immitation of search query
	    if (this.state.searchQuery) {
	      var searchStr = this.state.searchQuery;
	      (0, _api.fakeEventsAPISearch)(searchStr, this.CARDS.items).then(function (query) {
	        return _this5.setState({ query: query });
	      });
	    }
	  };
	
	  EventsContainer.prototype.handleInput = function handleInput(val) {
	    this.setState({
	      searchQuery: val
	    });
	  };
	
	  EventsContainer.prototype.render = function render() {
	    var arr = [].concat(this.state.query);
	    var loading = this.state.loading;
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(_FilterAndSearch2.default, {
	        area: 'fs',
	        items: this.props.menuFilter,
	        changeDates: this.handleDates,
	        search: this.handleSearch,
	        input: this.handleInput
	      }),
	      loading ? _react2.default.createElement(
	        _Titles.LoadingContent,
	        { area: 'cont' },
	        'Loading...'
	      ) : _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          _CardContainer2.default,
	          {
	            cols: this.CARDS.cols,
	            cards: this.CARDS.items },
	          arr.map(function (elem, index) {
	            return _react2.default.createElement(_ProjectCard2.default, {
	              key: index,
	              type: 'list',
	              title: elem.title,
	              text: elem.description,
	              img: elem.image,
	              list: [elem.date, elem.city, elem.country]
	            });
	          })
	        ),
	        _react2.default.createElement(_Pagination2.default, {
	          onChange: this.changePage,
	          background: this.props.theme.white,
	          pageNum: 2
	        })
	      )
	    );
	  };
	
	  return EventsContainer;
	}(_react2.default.Component);
	
	exports.default = (0, _styledComponents.withTheme)(EventsContainer);
	
	
	EventsContainer.propTypes = {
	  menuFilter: _propTypes2.default.array.isRequired,
	  theme: _propTypes2.default.PropTypes.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
	};
	module.exports = exports['default'];

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    flex: 1 0 8em;\n  '], ['\n    flex: 1 0 8em;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    flex: 1 1 10em;\n  '], ['\n    flex: 1 1 10em;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: 65%;\n  '], ['\n    width: 65%;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  min-height: 3.5em;\n  color: ', ';\n  margin: 0.5rem;\n  margin-bottom: auto;\n  padding: 0 0.5rem;\n  text-align: center;\n  display: ', ';\n  ', ' ', ' ', ' ', ';\n'], ['\n  min-height: 3.5em;\n  color: ', ';\n  margin: 0.5rem;\n  margin-bottom: auto;\n  padding: 0 0.5rem;\n  text-align: center;\n  display: ', ';\n  ', ' ', ' ', ' ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    font-size: 1.25rem;\n  '], ['\n    font-size: 1.25rem;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    font-size: 1.125rem;\n  '], ['\n    font-size: 1.125rem;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    min-height: 1.5em;\n    font-size: 1.125rem;\n  '], ['\n    min-height: 1.5em;\n    font-size: 1.125rem;\n  ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    font-size: 1.2rem;\n  '], ['\n    font-size: 1.2rem;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  margin-top: 0.5rem;\n  margin-bottom: auto;\n  padding: 0 0.5rem 0.8rem 0.5rem;\n  font-size: 1.125rem;\n  hyphens: auto;\n  ', ' ', ';\n'], ['\n  color: ', ';\n  margin-top: 0.5rem;\n  margin-bottom: auto;\n  padding: 0 0.5rem 0.8rem 0.5rem;\n  font-size: 1.125rem;\n  hyphens: auto;\n  ', ' ', ';\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    font-size: 1rem;\n  '], ['\n    font-size: 1rem;\n  ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n    font-size: 1.125rem;\n    padding: 0.5rem 0.5rem 1.2rem 0.5rem;\n  '], ['\n    font-size: 1.125rem;\n    padding: 0.5rem 0.5rem 1.2rem 0.5rem;\n  ']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  list-style-type: circle;\n  margin: 1rem;\n  padding: 0 0.5rem;\n  margin-bottom: auto;\n  ', ' ', ' ', ';\n'], ['\n  color: ', ';\n  list-style-type: circle;\n  margin: 1rem;\n  padding: 0 0.5rem;\n  margin-bottom: auto;\n  ', ' ', ' ', ';\n']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n    margin-left: 1rem;\n    margin-right: 0.2rem;\n    padding: 0;\n  '], ['\n    margin-left: 1rem;\n    margin-right: 0.2rem;\n    padding: 0;\n  ']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n    align-self: flex-start;\n    margin-left: 10%;\n  '], ['\n    align-self: flex-start;\n    margin-left: 10%;\n  ']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n    margin-left: 15%;\n  '], ['\n    margin-left: 15%;\n  ']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  font-size: 1.125rem;\n  hyphens: auto;\n  ', ';\n  ', ';\n'], ['\n  padding: 0;\n  font-size: 1.125rem;\n  hyphens: auto;\n  ', ';\n  ', ';\n']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n    font-size: 0.9rem;\n    margin: 0.25rem;\n  '], ['\n    font-size: 0.9rem;\n    margin: 0.25rem;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _globalStyle = __webpack_require__(6);
	
	var _faker = __webpack_require__(21);
	
	var _faker2 = _interopRequireDefault(_faker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'ProjectCard__Wrapper'
	})(['flex:1 0 10em;display:flex;flex-direction:column;justify-content:space-between;align-items:center;background:', ';border-radius:4px;padding-bottom:1rem;', ' ', ';'], function (props) {
	  return props.theme.primary.light;
	}, _globalStyle.media.tablet(_templateObject), _globalStyle.media.phone(_templateObject2));
	
	var Image = _styledComponents2.default.img.withConfig({
	  displayName: 'ProjectCard__Image'
	})(['border-radius:2px;display:block;width:80%;margin:1rem 0.5rem;', ';'], _globalStyle.media.phone(_templateObject3));
	
	var ProjectTitle = _globalStyle.StyledH3.extend(_templateObject4, function (props) {
	  return props.theme.white;
	}, function (props) {
	  return props.visibility || 'block';
	}, _globalStyle.media.giant(_templateObject5), _globalStyle.media.desktop(_templateObject6), _globalStyle.media.tablet(_templateObject7), _globalStyle.media.phone(_templateObject8));
	
	var ProjectP = _globalStyle.StyledP.extend(_templateObject9, function (props) {
	  return props.theme.white;
	}, _globalStyle.media.desktop(_templateObject10), _globalStyle.media.phone(_templateObject11));
	
	var CardUl = _globalStyle.StyledUl.extend(_templateObject12, function (props) {
	  return props.theme.white;
	}, _globalStyle.media.desktop(_templateObject13), _globalStyle.media.tablet(_templateObject14), _globalStyle.media.phone(_templateObject15));
	
	var CardLi = _globalStyle.StyledLi.extend(_templateObject16, _globalStyle.media.desktop(_templateObject17), _globalStyle.media.tablet(_templateObject10));
	
	var ProjectLi = function ProjectLi(props) {
	  return _react2.default.createElement(
	    CardUl,
	    { lang: 'en' },
	    _react2.default.createElement(
	      CardLi,
	      null,
	      props.data[0] || _faker2.default.date.future().toTimeString()
	    ),
	    _react2.default.createElement(
	      CardLi,
	      null,
	      (props.data[1] || _faker2.default.address.city()) + ', ' + (props.data[2] || _faker2.default.address.country())
	    ),
	    _react2.default.createElement(
	      CardLi,
	      null,
	      props.text
	    )
	  );
	};
	
	ProjectLi.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  text: _propTypes2.default.string.isRequired
	};
	
	var ProjectCard = function (_React$Component) {
	  _inherits(ProjectCard, _React$Component);
	
	  function ProjectCard() {
	    _classCallCheck(this, ProjectCard);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProjectCard.prototype.render = function render() {
	    return _react2.default.createElement(
	      Wrapper,
	      { lang: 'en' },
	      _react2.default.createElement(Image, { src: this.props.img }),
	      _react2.default.createElement(
	        ProjectTitle,
	        { visibility: this.props.heading },
	        this.props.title
	      ),
	      this.props.type === 'list' ? _react2.default.createElement(ProjectLi, { data: this.props.list, text: this.props.text }) : _react2.default.createElement(
	        ProjectP,
	        null,
	        this.props.text
	      )
	    );
	  };
	
	  return ProjectCard;
	}(_react2.default.Component);
	
	ProjectCard.propTypes = {
	  title: _propTypes2.default.string.isRequired, // card heading
	  text: _propTypes2.default.string.isRequired, // card text
	  img: _propTypes2.default.string, // img src
	  type: _propTypes2.default.string, // 'list' or 'text'
	  heading: _propTypes2.default.string, // 'none' or 'block'
	  list: _propTypes2.default.array
	};
	
	exports.default = ProjectCard;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(29);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _EventsContainer = __webpack_require__(238);
	
	var _EventsContainer2 = _interopRequireDefault(_EventsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventsPage = function EventsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Hero2.default, { type: 'events' }),
	    _react2.default.createElement(_EventsContainer2.default, {
	      menuFilter: data.site.siteMetadata.filterOptions.events
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = EventsPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-js-7e3d69f48e8dce017eab.js